<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="2"
                    :total="5" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-17",
            currentTrivia: 16,
            questions: {
                question: {
                    "title": "True/False: You can help guide a subject in what to say if you think it will help advance the case.",
                    "answers": [
                        {"key": "A", "answer": "True"},
                        {"key": "B", "answer": "False"},
                    ],
                    "correctAnswer": ["B"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
